import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { CivilCase } from './../../../civil/civil-case';
import { Abstract } from '../../../civil/civil-case-sections/abstract';

@Component({
  selector: 'app-judgments',
  templateUrl: './judgments.component.html',
  styleUrls: ['./../civil-case-view.component.less']
})
export class JudgmentsComponent implements OnInit, AfterViewInit {

  @Input() civilCase: CivilCase;
  @Input() abstractCode: string;  // the parent passes in either a J or Q so we know which abstracts to show

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // reset table column rowspans
     this.setRowspanForAbstactPaymentOnJudgmentTable();
  }

  /**
   * get transaction list for display: due to the adjustment amount row not existing in
   * the transaction list, copy the last one and add the list for UI looping purpose.
   *
   * @param abstract
   * @param payment
   */
  getAbstractPaymentTransactionDisplayList(abstract: Abstract, payment: any): any[] {
    const list = abstract.getAbstractPaymentTransactionList(payment);
    if (list && abstract.getShowAdjustedPayment(payment) === true) {
      // copied the last one (just for loop display for adjustment row)
      const lastItem = list[list.length - 1];
      list.push(lastItem);
    }
    return list;
  }

  /**
   * set the rowspans for the first paymenment number column and the first debtor column
   * in the payment on judgment table
   *
   */
  setRowspanForAbstactPaymentOnJudgmentTable(): void {
    const abstractList = this.civilCase.getAbstractList(this.abstractCode);  // ja
    let ja = 0;
    for ( let abstract of abstractList) {
      let paymentList = abstract.getAbstractPaymentList(); // py
      let py = 0;
      for (let payment of paymentList) {
        let transactionDisplayList = this.getAbstractPaymentTransactionDisplayList(abstract, payment); //tn
        if (transactionDisplayList.length > 0 ) {
          let transactionDisplayLen =  transactionDisplayList.length;
          let rowSpan = transactionDisplayLen;
          let tn = 0;
          // reset collumn rowspan for the first payment number and detor columns in each payment
          // tslint:disable-next-line:max-line-length
          let paymentNumberId: string = 'civil-caseDetails-judgmentAbstracts-' + ja + '-paymentsOnJudgment-' + py + '-' + tn + '-paymentNumber';
          let paymentDetorId: string = 'civil-caseDetails-judgmentAbstracts-' + ja + '-paymentsOnJudgment-' + py + '-' + tn + '-debtor';
          let paymentNumberElement: HTMLElement = document.getElementById(paymentNumberId);
          let paymentDetorElement: HTMLElement = document.getElementById(paymentDetorId);
          paymentNumberElement.setAttribute('rowspan',  '' + rowSpan );
          paymentDetorElement.setAttribute('rowspan', '' + rowSpan);
        }
        py++;
      }
      ja++;
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/civil/judgments/judgments.component.ts